export class Collection {
  id: string;
  name: string;
  description: string;
  import_id: string;
  created_at: string;
  updated_at: string;
  remarks?: string;
}
